import React, {useEffect, useState, useRef, useContext} from "react";
import {store} from '../context/store';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

import {CATEGORY_TYPE_CATEGORY} from "../constants/charts";
import {CATEGORY_TYPE_DATE} from "../constants/charts";
import {SERIES_TYPE_LINE} from "../constants/charts";
import {SERIES_TYPE_COLUMN} from "../constants/charts";
import {SERIES_TYPE_BUBBLE} from "../constants/charts";
import {LICENCE_KEY} from "../constants/charts";
import {TRUE} from "../constants/general-constants";
import {DEFAULT_BLUE} from "../constants/general-constants";

//am4core.useTheme(am4themes_animated);
am4core.addLicense(LICENCE_KEY);


export default function AmChartXY({chartId, width, height, props, chartData, chartGraphs, categoryType, 
	categoryKey, hideLabels, additionalAxes, xAxisTitle, yAxisTitle, seriesClick, labelsRotate,
	bubbleHover, comments, positiveNegative, extraMinMax, positiveGreen, chartRotate, chartTitle, minMax, targetQuarter, setYellow, onClick}){

	const chart = useRef(null);
	const globalState = useContext(store);

	useEffect(() => {
		
		displayChart();
		

	}, [chartData, chartGraphs]);
	
	const displayChart = ()  => {
		let x = am4core.create(chartId, am4charts.XYChart);
		
		x.paddingRight = 20;
		x.stroke = "#666";
		x.strokeOpacity = "0";
  
    x.fontSize = 12;
    x.fill=am4core.color('black');
    
    Object.entries(props).map(([key, value]) => {
    	x[key] = value;
    });
    
   
	  
		if(categoryType == CATEGORY_TYPE_DATE){
	    let dateAxis = x.xAxes.push(new am4charts.DateAxis());
	   	buildAxisDisplay(dateAxis, true, xAxisTitle);
	   	
		}
		else{
			let categoryAxis = x.xAxes.push(new am4charts.CategoryAxis());
			categoryAxis.dataFields.category=categoryKey;
			buildAxisDisplay(categoryAxis, true, xAxisTitle);	 
			
	   	if(targetQuarter && targetQuarter != "Not Before 2071"){
				try{
					let range = categoryAxis.axisRanges.create();
					range.category = targetQuarter;
					range.grid.strokeOpacity = 1;
					range.grid.strokeWidth = 10;
					range.grid.stroke = "#ffcc00";
				}
				catch(e){
					console.log(e);	
				}
			}
			
			
			
	   	try{
				x.events.on("ready", function(){
					categoryAxis.zoomToCategories("Q1 2016", "Q4 2024", false, true);
				});
			}
			catch(e){
			}
		}

    let valueAxis = x.yAxes.push(new am4charts.ValueAxis());
    valueAxis.tooltip.disabled = true;
    valueAxis.renderer.minWidth = 25;
    valueAxis.maxPrecision=0;
   
    
    if(minMax){
    	try{
		    valueAxis.min = minMax[0].min;
				valueAxis.max = minMax[0].max;
				valueAxis.strictMinMax = true;
			}
			catch(e){}
		}
		else{
			//valueAxis.min = 0;
		}
		
  	buildAxisDisplay(valueAxis, false, yAxisTitle);
	  
	  if(additionalAxes && additionalAxes.length > 0){
	  	for(var i=0; i<additionalAxes.length; i++){
	  		let valueAxisAdditional = x.yAxes.push(new am4charts.ValueAxis());
		    valueAxisAdditional.tooltip.disabled = true;
		    if(minMax){
		    	try{
				    valueAxisAdditional.min = minMax[i + 1].min;
				    valueAxisAdditional.max = minMax[i + 1].max;
				    valueAxisAdditional.strictMinMax = true;
				   }
				   catch(e){}
			   }
			   else{
					//valueAxisAdditional.min = 0;
				}
		    valueAxisAdditional.renderer.minWidth = 35;
		    if(additionalAxes[i].opposite && additionalAxes[i].opposite == "true"){
		    	valueAxisAdditional.renderer.opposite = true;
		    }
		  	buildAxisDisplay(valueAxisAdditional, false, additionalAxes[i].title);
	  	}
	  }
		
    let seriesArray = [];
    
    if(chartGraphs){
	    for(var i=0; i<chartGraphs.length; i++){
	    	var thisGraph = chartGraphs[i];
	    	
	    	if(thisGraph.seriesType && thisGraph.seriesType == SERIES_TYPE_COLUMN){
	    		let series = x.series.push(new am4charts.ColumnSeries());
	    		series.strokeWidth = 0;
	    		seriesArray.push(series);
	    		seriesArray[i].columns.template.column.cornerRadiusTopLeft = 3;
	    		seriesArray[i].columns.template.column.cornerRadiusTopRight = 3;
	    		seriesArray[i].columns.template.column.cornerRadiusBottomLeft = 3;
	    		seriesArray[i].columns.template.column.cornerRadiusBottomRight = 3;
	    		
	    		seriesArray[i].columns.template.events.on("hit", function(event) {
						onClick(event.target.dataItem.properties.category);
					});
		    		
		    	if(positiveNegative && positiveNegative == "true"){
		    		seriesArray[i].strokeWidth = 0;
		    		seriesArray[i].columns.template.adapter.add("fill", function(fill, target){
		    			if(positiveGreen && positiveGreen == true){
			    			if(target.dataItem && target.dataItem.valueY > 0){
			    				return "#090";
			    			}
			    			else{
			    				return "#d00";
			    			}
			    		}
			    		else{
			    			if(target.dataItem && target.dataItem.valueY > 0){
			    				return "#d00";
			    			}
			    			else{
			    				return "#090";
			    			}
			    		}
		    		});
		    	}	
		    	
		    	if(setYellow && setYellow === TRUE){
		    		if(seriesArray && seriesArray[0]){
		    			seriesArray[i].columns.template.adapter.add("fill", function(fill, target){
		    				return "#ffcc00"
		    			});
		    		}
		    	}
		    		
		    		
	    	}
	    	else{
	    		let series = x.series.push(new am4charts.LineSeries());
	    		seriesArray.push(series);
	    		series.strokeWidth = 2;
	    		var bullet = series.bullets.push(new am4charts.Bullet());
	    		if(seriesClick){
	    			bullet.events.on('hit', seriesClick, this);
	    		}
	    		var circle = bullet.createChild(am4core.Circle);
	    		circle.radius=3;
	    		circle.fill="white";
	    		circle.stroke = "black";
	    		circle.strokeWidth = "1";
	    		circle.strokeOpacity="1";
	    	}
	    	
	    	if(categoryType && categoryType == CATEGORY_TYPE_DATE){
	    		seriesArray[i].dataFields.dateX = categoryKey;
	    	}
	    	else{
	    		seriesArray[i].dataFields.categoryX = categoryKey;
	    	}
	    	
	    	if(thisGraph.seriesType && thisGraph.seriesType  == SERIES_TYPE_BUBBLE){
	    		seriesArray[i].dataFields.value = thisGraph.valueKey;
	    	}
	    	
	    	if(thisGraph.yKey){
	    		seriesArray[i].dataFields.valueY = thisGraph.yKey;
	    	}
	    	else{
	    		seriesArray[i].dataFields.valueY = thisGraph.ykey;
	    	}
	    	
	   		seriesArray[i].showTooltipOn = true;
	    	seriesArray[i].name=thisGraph.name;
	    	seriesArray[i].tooltipText = thisGraph.name + ": {valueY.value}";
	    	
	    	if(thisGraph.stacked && thisGraph.stacked==true){
	    		seriesArray[i].stacked=true;
	    	}
	    	
	    	if(thisGraph.columnWidth){
	    		seriesArray[i].columns.template.width = am4core.percent(parseInt(thisGraph.columnWidth));
	    	}
	    	
	    	if(thisGraph.color){
	    		if(thisGraph.seriesType && (thisGraph.seriesType == SERIES_TYPE_COLUMN || thisGraph.seriesType == SERIES_TYPE_BUBBLE)){
		    		seriesArray[i].fill = thisGraph.color;
		    		seriesArray[i].stroke = thisGraph.color;
		    		seriesArray[i].fillOpacity = 0.8;
		    		seriesArray[i].strokeWidth = 1;
		    		seriesArray[i].strokeOpacity = 0.5;
		    		
		    	}
		    	else if(thisGraph.seriesType && thisGraph.seriesType == SERIES_TYPE_LINE){
		    		seriesArray[i].stroke = thisGraph.color;
		    		seriesArray[i].fill = thisGraph.color;
		    		seriesArray[i].strokeWidth = 2;
		    	}
	    	}
	    	
	    	if(thisGraph.seriesType && thisGraph.seriesType == SERIES_TYPE_BUBBLE){
		    		seriesArray[i].strokeOpacity=0;
		    		seriesArray[i].fillOpacity=0;
		    		var bullet = seriesArray[i].bullets.push(new am4charts.CircleBullet());
	    			bullet.fillOpacity=0.8;
	    			bullet.strokeOpacity = 1;
	    			bullet.events.on("hit", seriesClick, this);
	    			bullet.propertyFields.fill = "color";
						bullet.propertyFields.stroke = "color";
	    			if(bubbleHover){
	    				bullet.events.on('over', bubbleHover, this);
	    			}
	    			seriesArray[i].heatRules.push({
	    				target: bullet.circle,
	    				min:10,
	    				max:70,
	    				property:"radius"
	    			});
		    		seriesArray[i].tooltipText = "{name}, Expenditure:{valueY}, Income:{value}";
		    }
	    	
	    	if(thisGraph.bullets && thisGraph.bullets == true){
	    		var bullet = seriesArray[i].bullets.push(new am4charts.Bullet());
	    		if(seriesClick){
	    			bullet.events.on('hit', seriesClick, this);
	    		}
	    		var circle = bullet.createChild(am4core.Circle);
	    		circle.radius=3;
	    		circle.fill="#fff";
	    		circle.stroke = "black";
	    		circle.strokeWidth = "2";
	    	}
	    	
	    	if(additionalAxes && additionalAxes.length > 0){
		    	if(thisGraph.additionalAxisAddress){
		    		seriesArray[i].yAxis = x.yAxes.values[thisGraph.additionalAxisAddress];
		    	}
		    	else{
		    		seriesArray[i].yAxis = x.yAxes.values[0];
		    	}
		    }
		    
		    if(seriesClick && thisGraph.seriesType){
		    	if(thisGraph.seriesType == SERIES_TYPE_COLUMN){
		    		seriesArray[i].columns.template.events.on("hit", seriesClick, this);
		    	}
		    }
		    
	    }
    }
    
    if(comments){
    	
    	let series = x.series.push(new am4charts.LineSeries());
    	series.yAxis = x.yAxes.values[0];
  		series.strokeOpacity=0;
  		series.fillOpacity=0;
  		series.fill = "#fff";
			if(categoryType && categoryType == CATEGORY_TYPE_DATE){
    		series.dataFields.dateX = categoryKey;
    	}
    	else{
    		series.dataFields.categoryX = categoryKey;
    	}
    	series.dataFields.valueY = "commentvalue";
  		var bullet = series.bullets.push(new am4charts.CircleBullet());
			var circle = bullet.createChild(am4core.Circle);
	    circle.radius=20;
	    circle.fill="#fff";
	    circle.stroke = "#000";
	    circle.strokeWidth = "1";
	    
	    var shadow = new am4core.DropShadowFilter();
	    shadow.dx = 2;
	    shadow.dy = 2;
	    circle.filters.push(shadow);
	    
			bullet.events.on("hit", seriesClick, this);
			
  		series.tooltipText = "{comment}";
  		series.tooltip.label.wrap=true;
  		series.tooltip.label.width=300;
  		series.tooltip.label.fill="#fff";
  		
  		for(var i=0; i<chartData.length; i++){
  			for(var j=0; j<comments.length; j++){
  				if(chartData[i][categoryKey] == comments[j].category){
  					chartData[i].commentvalue = comments[j].value;
  					chartData[i].comment = comments[j]["comment"];
  				}
  			}
  		}
  		
    }
    
    
    if(x.showCursor && x.showCursor==true){
    	x.cursor = new am4charts.XYCursor();
    }
    
    if(x.showLegend && x.showLegend==true){
    	let legend = new am4charts.Legend();
    	legend.labels.template.strokeOpacity=0; 
    	legend.labels.template.fillOpacity=1; 
    	legend.labels.template.fill='black'; 
    	x.legend = legend;
    }
    

		if(x.showScrollbar && x.showScrollbar==true){
	    let scrollbarX = new am4charts.XYChartScrollbar();
	    scrollbarX.background.fill = am4core.color("#000");
	    scrollbarX.background.fillOpacity = 0.1;
	    scrollbarX.unselectedOverlay.fill = am4core.color("#fff");
	    scrollbarX.unselectedOverlay.fillOpacity=0.2;
	  	
	    
	    if(seriesArray){
		    for(var i=0; i<seriesArray.length; i++){
		    	scrollbarX.series.push(seriesArray[i]);
		    }
		  }
	    x.scrollbarX = scrollbarX;
	    
	   
	    
		}
		
		if(x.show2Scrollbars && x.show2Scrollbars == true){
			x.scrollbarX = new am4core.Scrollbar();
			x.scrollbarY = new am4core.Scrollbar();
		}
		
		if(x.showScrollbarY && x.showScrollbarY == true){
			x.scrollbarY = new am4core.Scrollbar();
		}
		
		x.data = chartData;
		x.numberFormatter.numberFormat = "#.0a";
		x.numberFormatter.bigNumberPrefixes = [
			{"number":1e+3, "suffix":"K"},
			{"number":1e+6, "suffix":"M"},
			{"number":1e+9, "suffix":"Bn"}
		];
		
		if(chartTitle){
			let title = x.titles.create();
			title.text = chartTitle;
			title.fontSize = 25;
			title.marginBottom = 20;
			title.fillOpacity = 1;
			title.fill = 'black';
			title.strokeOpacity = 0;
		}
		
	
		
		chart.current = x;
		
		if(seriesArray){
		    for(var i=0; i<seriesArray.length; i++){
		    	if(x.showScrollbar && x.showScrollbar==true){
						let scrollSeries = x.scrollbarX.scrollbarChart.series.getIndex(i);
						let scrollAxis = x.scrollbarX.scrollbarChart.xAxes.getIndex(0);
						scrollAxis.renderer.labels.template.disabled = true;
						scrollSeries.bullets.clear();
			    	scrollSeries.filters.clear();
			    	scrollSeries.fillOpacity = 0.9;
			    	scrollSeries.stroke = am4core.color("rgba(255,255,255, 0.3)");
			    	scrollSeries.strokeOpacity=0.5;
			    	scrollSeries.fill = am4core.color("rgba(0,0,0,0.2)");
			    }
		    }
		}
		
		return () => {
			x.dispose();
		};
	};
	
	
	const buildAxisDisplay =(axis, isXAxis, axisTitle) => {
		 
		 	axis.renderer.grid.template.stroke = "#999";
		  
	    axis.renderer.axisFills.template.disabled = false;
	    if(isXAxis == true){
	    	axis.renderer.axisFills.template.fillOpacity = 0.15;
	    	axis.renderer.grid.template.strokeOpacity = 0;
	    	axis.renderer.minGridDistance = 30;
				//axis.renderer.grid.template.strokeDasharray = "1,3";
				if(labelsRotate && labelsRotate == "true"){
					axis.renderer.labels.template.rotation=270;
				}
	    }
	    else{
	    	axis.renderer.axisFills.template.fillOpacity = 0;
	    	axis.renderer.grid.template.strokeOpacity = 0;
	    	if(extraMinMax){
	    		axis.extraMin = extraMinMax;
					axis.extraMax = extraMinMax;
	    	}
	    	else{
	    		axis.extraMin = 0.1;
					axis.extraMax = 0.1;	
	    	}
	    	
	    }
			
			axis.renderer.axisFills.template.strokeOpacity = 0;
			axis.renderer.axisFills.template.fill = am4core.color("#999");
			axis.renderer.labels.template.fontSize=12;
			axis.renderer.labels.template.strokeOpacity=0;
			axis.renderer.labels.template.fillOpacity=1;
			axis.renderer.labels.template.fill='black';
			
			axis.title.text=axisTitle;
			axis.title.fontSize = 12;
			axis.title.fontWeight = "bold";
			axis.title.strokeOpacity=0;
			axis.title.fillOpacity=1;
			axis.title.fill='black';
			
			if(hideLabels && hideLabels == "true"){
	    	axis.renderer.labels.template.fontSize=0;
	  	}
	}
		
	return (
		<div id={chartId} style={{ width: width, height: height }}></div>
	);
}